import React, { useEffect, useState } from 'react';
import UsuarioService from './services/usuarioService';

const usuarioService = new UsuarioService();

interface ProtectedActionProps {
  children: React.ReactNode;
  fallback?: React.ReactNode; 
}

export const ProtectedActionInterno: React.FC<ProtectedActionProps> = ({ children, fallback = null }) => {
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const response = await usuarioService.verificaTipoUsuario();
        
        const dados = response.data; 
        const tipoAcesso = (dados?.tipo || '').toUpperCase();     
        const nomePerfil = (dados?.perfil || '').toUpperCase();   

        const acessoPermitido = tipoAcesso.includes('INTERNO') || nomePerfil.includes('MASTER');

        setHasAccess(acessoPermitido);

      } catch (error) {
        console.error("Erro ao validar permissão de interno:", error);
        setHasAccess(false); 
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, []); 

  if (loading) return null; 
  if (!hasAccess) return <>{fallback}</>;

  return <>{children}</>;
};

export const ProtectedAction: React.FC<ProtectedActionProps> = ({ children, fallback = null }) => {
  const [loading, setLoading] = useState(true);
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const response = await usuarioService.verificaTipoUsuario();
        
        const dados = response.data;
        const tipoAcesso = (dados?.tipo || '').toUpperCase();
        
        const isReadOnly = tipoAcesso.includes('CONSULTA');

        setCanEdit(!isReadOnly);

      } catch (error) {
        console.error("Erro ao validar permissão:", error);
        setCanEdit(false); 
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, []); 

  if (loading) return null; 
  if (!canEdit) return <>{fallback}</>;

  return <>{children}</>;
};

export const ProtectedActionOriginador: React.FC<ProtectedActionProps> = ({ children, fallback = null }) => {
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const response = await usuarioService.verificaTipoUsuario();
        
        const dados = response.data;
        const tipoAcesso = (dados?.tipo || '').toUpperCase();
        const nomePerfil = (dados?.perfil || '').toUpperCase(); 

        const isReadOnly = tipoAcesso.includes('CONSULTA');
        const canEdit = !isReadOnly;

        const isOriginador = nomePerfil.includes('ORIGINADOR');

        setHasAccess(canEdit || isOriginador);

      } catch (error) {
        console.error("Erro ao validar permissão de originador:", error);
        setHasAccess(false); 
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, []); 

  if (loading) return null; 

  if (!hasAccess) return <>{fallback}</>;

  return <>{children}</>;
};